import { useCurrentUser } from 'src/hooks/useCurrentUser';

function useAuthenticated() {
  const user = useCurrentUser();

  return !!user;
}

export default useAuthenticated;
